var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"id":"Vector","d":"M16.5 8.93143L1.5 8.93143M16.5 8.93143L9.21429 16.0714M16.5 8.93143L9.21429 1.5","stroke-linecap":"round","stroke-linejoin":"round"}})}
var staticRenderFns = []

export { render, staticRenderFns }